import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAddPlanzoneResourceToProjectRequestFailure({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isAddPlanzoneResourceToProjectRequestPending({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isAddPlanzoneResourceToProjectRequestSuccess({ uuid }) {
      const req = getState().find(({ resource }) => resource.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
